import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { SmRefTypeLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';

interface SmRefTypeProps {
    label: string;
    disabled?: boolean;
    value: string;
    menuPlacement?: MenuPlacement;
    addAll?: boolean;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string) => void;
}

const allOption = { value: '__all__', label: 'Alle' };

export const SmRefType: React.FC<SmRefTypeProps> = ({
    label,
    value,
    disabled = false,
    menuPlacement = 'bottom',
    renderLabel = 'label',
    onChange,
    allowEmpty = false,
    addAll = false,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];
        if (addAll) {
            list.push(allOption);
        }

        Object.keys(SmRefTypeLabel).forEach((key) => {
            list.push({
                value: key,
                label: SmRefTypeLabel[key],
            });
        });

        if (allowEmpty) {
            list.push({ value: '', label: '' });
        }

        return list;
    }, [addAll, allowEmpty]);

    const selectedOption = React.useMemo(() => {
        if (value === '__all__') {
            return allOption;
        }

        if (value) {
            return {
                value,
                label: SmRefTypeLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <Select
                name="smreftype"
                isDisabled={disabled}
                value={selectedOption}
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '__all__');
                }}
                placeholder={renderLabel === 'placeholder' ? 'Referenz-Art' : ''}
            />
        </>
    );
};
